import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';


@Component({
    selector: 'app-homeowners',
    templateUrl: './homeowners.component.html',
    styleUrls: ['./homeowners.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeownersComponent implements OnInit {
  status = false;
  constructor() {

  }

  ngOnInit() {
  }

}
